export const PRESS_RELEASE_IMAGES = {
    '21': ['pr21_1.png', 'pr21_2.png'],
    '22': ['FPRT-2024-22.1.png', 'FPRT-2024-22.2.png'],
    '23': ['FPRT-2025-23.1.png', 'FPRT-2025-23.2.png', 'FPRT-2025-23.3.png', 'FPRT-2025-23.4.png'],
    '24': ['FPRT-2025-24.1.png', 'FPRT-2025-24.2.png'],
  };